<div
    class="sidenav_container"
    [@onSideNavChange]="sideNavState ? 'open' : 'close'"
    [ngClass]="sideNavState ? 'opened' : 'closed'"
>
    <div class="logo-row">
        <div class="logo-wrapper">
            <img class="logo-large" src="assets/aumico-logo-4c-white.svg" />
            <img class="logo-small" src="assets/aumico-logo-small.svg" />
        </div>
    </div>

    <div fxLayout="column" class="primary-nav-row" fxLayoutAlign="stretch">
        <div>
            <mat-nav-list class="primary nav-list">
                <a
                    mat-list-item
                    *ngFor="let page of primaryNavigation$ | async"
                    [routerLink]="page.path"
                    (click)="onClick(page)"
                    [class.active]="
                        page && page.data && page.data['label'] === (activePage$ | async)
                            ? (activePage$ | async).data['label']
                            : false
                    "
                >
                    <mat-icon svgIcon="{{ page?.data.icon }}"></mat-icon>
                    <span [@animateText]="linkText ? 'show' : 'hide'">{{ page?.data?.label | i18next }} </span>
                </a>
            </mat-nav-list>
        </div>

        <div fxFlex="100">
            <mat-divider></mat-divider>
            <div></div>
        </div>

        <div>
            <mat-nav-list class="secondary nav-list">
                <ng-container *ngFor="let page of secondaryNavigation$ | async">
                    <a
                        mat-list-item
                        *ngIf="page.path"
                        [routerLink]="page.path"
                        (click)="onClick(page)"
                        [class.active]="
                            page && page.data && page.data['label'] === (activePage$ | async)
                                ? (activePage$ | async).data['label']
                                : false
                        "
                    >
                        <mat-icon svgIcon="{{ page?.data.icon }}"></mat-icon>
                        <span [@animateText]="linkText ? 'show' : 'hide'"
                            >{{ page?.data?.label || '' | i18next }}
                        </span>
                    </a>
                    <a mat-list-item *ngIf="!page.path" (click)="page.action()">
                        <mat-icon svgIcon="{{ page?.data.icon }}"></mat-icon>
                        <span [@animateText]="linkText ? 'show' : 'hide'"
                            >{{ page?.data?.label || '' | i18next }}
                        </span>
                    </a>
                </ng-container>
            </mat-nav-list>
        </div>

        <div class="user nav-list">
            <div>
                <mat-nav-list>
                    <a mat-list-item [routerLink]="(userNavigation$ | async)?.path">
                        <img class="jim" src="assets/aumico-avatar-white-background.svg" />
                        <span [@animateText]="linkText ? 'show' : 'hide'">
                            {{ (user$ | async)?.name }}
                        </span>
                    </a>
                </mat-nav-list>
            </div>
        </div>
    </div>

    <span class="spacer"></span>
</div>
